import React from 'react'
import './css/HomePageRedBanner.scss'
import { QRCodeSVG } from 'qrcode.react'
import { Link } from 'react-router-dom'

function HomePageFiba(props: any) {
  const accountCodeRemote = props?.user?.AccountCodeRemote?.replace("0000", "")
  const accountCode = props?.user?.AccountCode?.replace("0000", "")
  const lastAccount = accountCodeRemote ? accountCodeRemote : accountCode
  const qrUrl = `https://fibasigorta.com.tr/teklif-al/elektronik-cihaz-index/?isbirligi=${lastAccount}`

  return (
    <>
      {lastAccount && (
        <div className="fiba-wrapper">
          <h2 className="fiba-title"><Link to={"/myspecial/Fiba"}>Fibabank Cihaz Sigortası</Link></h2>
          <a href={qrUrl} target="_blank" rel="noreferrer" className="fiba-qr-link">
            <QRCodeSVG value={qrUrl} size={180} className="fiba-qr" />
          </a>
        </div>
      )}
    </>
  )
}

export default HomePageFiba